import React from 'react';
import { DefaultTheme } from 'styled-components';

interface Props {
  theme?: DefaultTheme;
}

const IllustrationProspectView: React.FC<React.PropsWithChildren<Props>> = ({
  theme,
  ...otherProps
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="304"
      height="304"
      fill="none"
      viewBox="0 0 304 304"
      {...otherProps}
    >
      <path stroke="#C0C2C9" d="M10 297.5L300 297.5"></path>
      <path
        fill="#F0F1F3"
        d="M278.294 46.075l-1.748-2.875C261.831 18.976 235.227 4.372 207.17 6.145c-3.618.228-7.214.72-10.76 1.471-25.501 5.455-47.694 24.721-56.894 49.395-5.38 14.51-6.92 31.224-17.189 42.738-13.362 14.993-36.046 15.45-55.986 14.839-19.94-.611-42.643-.087-55.938 14.96C2.077 138.953-.573 152.388.1 164.997c1.795 33.434 25.084 63.314 54.755 78.166 29.67 14.853 64.56 16.183 97.002 9.654 45.488-9.157 88.683-34.294 114.668-73.115 25.986-38.821 32.556-91.716 11.769-133.627z"
      ></path>
      <ellipse cx="63.5" cy="55" fill="#F0F1F3" rx="47.5" ry="47"></ellipse>
      <g filter="url(#filter0_dd)">
        <mask
          id="mask0"
          style={{ maskType: 'alpha' }}
          width="256"
          height="173"
          x="16"
          y="52"
          maskUnits="userSpaceOnUse"
        >
          <rect
            width="254.604"
            height="173"
            x="16.698"
            y="52"
            fill="#fff"
            rx="4"
          ></rect>
        </mask>
        <g mask="url(#mask0)">
          <rect
            width="254.604"
            height="173"
            x="16.698"
            y="52"
            fill="#fff"
            rx="4"
          ></rect>
          <path
            fill="#FBFBFB"
            stroke="#E9EAEC"
            d="M16.545 84.488H67.119V225.152H16.545z"
          ></path>
          <circle cx="25.512" cy="93.454" r="4.243" fill="#DBDDE1"></circle>
          <path
            fill="#A4A8B2"
            d="M61.136 93.781c0 .091-6.123.17-13.67.17s-13.67-.078-13.67-.17c0-.091 6.117-.17 13.67-.17s13.67.06 13.67.17z"
          ></path>
          <circle cx="25.512" cy="106.511" r="4.243" fill="#DBDDE1"></circle>
          <path
            fill="#A4A8B2"
            d="M33.796 106.838c0 .091 6.123.169 13.67.169s13.67-.078 13.67-.169c0-.092-6.117-.17-13.67-.17s-13.67.059-13.67.17z"
          ></path>
          <circle
            cx="25.512"
            cy="119.568"
            r="4.243"
            fill={theme ? theme.primary[500] : '#DBDDE1'}
          ></circle>
          <path
            fill={theme ? theme.primary[500] : '#A4A8B2'}
            d="M61.136 119.894c0-.092-6.123-.17-13.67-.17s-13.67.078-13.67.17c0 .091 6.117.169 13.67.169s13.67-.058 13.67-.169z"
          ></path>
          <circle cx="25.512" cy="132.624" r="4.243" fill="#DBDDE1"></circle>
          <path
            fill="#A4A8B2"
            d="M33.796 132.95c0-.091 6.123-.169 13.67-.169s13.67.078 13.67.169c0 .092-6.117.17-13.67.17s-13.67-.059-13.67-.17z"
          ></path>
          <circle cx="25.512" cy="145.681" r="4.243" fill="#DBDDE1"></circle>
          <path
            fill="#A4A8B2"
            d="M61.136 146.008c0 .091-6.123.169-13.67.169s-13.67-.078-13.67-.169c0-.092 6.117-.17 13.67-.17s13.67.059 13.67.17z"
          ></path>
          <circle cx="25.512" cy="158.738" r="4.243" fill="#DBDDE1"></circle>
          <path
            fill="#A4A8B2"
            d="M33.796 159.064c0 .092 6.123.17 13.67.17s13.67-.078 13.67-.17c0-.091-6.117-.169-13.67-.169s-13.67.058-13.67.169z"
          ></path>
          <circle cx="25.512" cy="216.187" r="4.243" fill="#DBDDE1"></circle>
          <path
            fill="#A4A8B2"
            d="M61.136 216.513c0 .092-6.123.17-13.67.17s-13.67-.078-13.67-.17c0-.091 6.117-.169 13.67-.169s13.67.059 13.67.169z"
          ></path>
          <path fill="#E9EAEC" d="M16.698 52H271.302V68.321H16.698z"></path>
          <path
            fill="#F7F8FB"
            d="M16.698 68.32H271.302V84.64099999999999H16.698z"
          ></path>
          <path
            fill="#F7F8FB"
            d="M62.397 57.223h39.169l6.529 16.32H55.868l6.529-16.32z"
          ></path>
          <circle
            cx="24.859"
            cy="60.16"
            r="2.285"
            fill={theme ? theme.primary[500] : '#A4A8B2'}
          ></circle>
          <circle
            cx="31.387"
            cy="60.16"
            r="2.285"
            fill={theme ? theme.primary[400] : '#A4A8B2'}
          ></circle>
          <circle
            cx="37.915"
            cy="60.16"
            r="2.285"
            fill={theme ? theme.primary[300] : '#A4A8B2'}
          ></circle>
          <path
            stroke="#F0F1F3"
            strokeWidth="0.5"
            d="M78.314 147.563H260.606V237.154H78.314z"
          ></path>
          <path
            fill="#222"
            d="M113.363 155.147c0 .098-6.124.17-13.67.17-7.547 0-13.67-.072-13.67-.17 0-.098 6.116-.169 13.67-.169 7.553 0 13.67.091 13.67.169z"
          ></path>
          <path
            fill={theme ? theme.primary[500] : '#DBDDE1'}
            d="M114.433 162.975h-28.41v28.411h28.41v-28.411z"
          ></path>
          <path
            fill="#222"
            d="M232.041 169.673c0 .091-22.938.169-51.245.169s-51.25-.078-51.25-.169c0-.092 22.938-.17 51.25-.17 28.311 0 51.245.072 51.245.17zM157.233 180.366c0 .098-5.848.17-13.055.17s-13.058-.072-13.058-.17c0-.098 5.843-.17 13.058-.17s13.055.079 13.055.17z"
          ></path>
          <path
            fill="#C0C2C9"
            d="M250.588 190.29c0 .091-26.748.169-59.734.169-32.986 0-59.734-.078-59.734-.169 0-.092 26.742-.177 59.734-.177 32.992 0 59.734.079 59.734.177z"
          ></path>
          <path
            fill="#DBDDE1"
            d="M180.839 156.068c0 .098-11.098.17-24.807.17-13.71 0-24.808-.072-24.808-.17 0-.098 11.098-.17 24.808-.17 13.709 0 24.807.079 24.807.17z"
          ></path>
          <path
            fill="#222"
            d="M211.163 180.288c0 .091-10.687.17-23.874.17s-23.88-.079-23.88-.17c0-.091 10.693-.17 23.88-.17s23.874.072 23.874.17zM242.023 180.203c0 .098-5.595.17-12.489.17-6.894 0-12.495-.072-12.495-.17 0-.098 5.595-.17 12.495-.17 6.9 0 12.489.079 12.489.17zM113.363 199.71c0 .098-6.124.17-13.67.17-7.547 0-13.67-.072-13.67-.17 0-.098 6.116-.17 13.67-.17 7.553 0 13.67.091 13.67.17z"
          ></path>
          <path
            fill={theme ? theme.primary[500] : '#DBDDE1'}
            d="M114.433 207.537h-28.41v28.411h28.41v-28.411z"
          ></path>
          <path
            fill="#222"
            d="M232.041 214.235c0 .092-22.938.17-51.245.17s-51.25-.078-51.25-.17c0-.091 22.938-.17 51.25-.17 28.311 0 51.245.072 51.245.17zM157.233 224.929c0 .097-5.848.169-13.055.169s-13.058-.072-13.058-.169c0-.098 5.843-.17 13.058-.17s13.055.078 13.055.17z"
          ></path>
          <path
            fill="#DBDDE1"
            d="M180.839 200.631c0 .098-11.098.169-24.807.169-13.71 0-24.808-.071-24.808-.169 0-.098 11.098-.17 24.808-.17 13.709 0 24.807.078 24.807.17z"
          ></path>
          <path
            fill="#222"
            d="M211.163 224.85c0 .092-10.687.17-23.874.17s-23.88-.078-23.88-.17c0-.091 10.693-.169 23.88-.169s23.874.071 23.874.169zM242.023 224.765c0 .098-5.595.17-12.489.17-6.894 0-12.495-.072-12.495-.17 0-.097 5.595-.169 12.495-.169 6.9 0 12.489.078 12.489.169zM167.783 103.188c0 .098-11.099.17-24.808.17s-24.808-.072-24.808-.17c0-.098 11.099-.169 24.808-.169s24.808.078 24.808.169zM231.76 110.37c0 .098-25.409.17-56.796.17-31.388 0-56.797-.072-56.797-.17 0-.098 25.409-.17 56.797-.17 31.387 0 56.796.079 56.796.17zM199.771 117.551c0 .098-18.253.169-40.802.169-22.548 0-40.802-.071-40.802-.169 0-.098 18.254-.17 40.802-.17 22.549 0 40.802.078 40.802.17z"
          ></path>
          <mask
            id="mask1"
            style={{ maskType: 'alpha' }}
            width="32"
            height="33"
            x="78"
            y="93"
            maskUnits="userSpaceOnUse"
          >
            <rect
              width="31.336"
              height="31.336"
              x="78.064"
              y="93.781"
              fill="#F0F1F3"
              rx="4"
            ></rect>
          </mask>
          <g mask="url(#mask1)">
            <rect
              width="31.336"
              height="31.336"
              x="78.064"
              y="93.781"
              fill="#F0F1F3"
              rx="4"
            ></rect>
            <circle cx="93.732" cy="106.185" r="5.875" fill="#DBDDE1"></circle>
            <circle cx="93.732" cy="134.91" r="20.238" fill="#DBDDE1"></circle>
          </g>
          <path
            fill="#C0C2C9"
            d="M261.033 136.065c0 .098-40.919.17-91.389.17s-91.404-.072-91.404-.17c0-.098 40.919-.169 91.404-.169 50.486 0 91.389.078 91.389.169z"
          ></path>
        </g>
      </g>
      <path
        fill={theme ? theme.secondary[700] : '#6E7382'}
        d="M266.566 260.105c.519-1.784 1.621-3.498 3.335-4.251 1.715-.752 3.837-.332 5.657.333 1.819.665 3.609 1.545 5.539 1.662 1.93.116 4.117-.793 4.694-2.642.542-1.749-.507-3.592-1.813-4.857a11.464 11.464 0 00-18.771 4.507"
      ></path>
      <path
        fill={theme ? theme.secondary[600] : '#888D9B'}
        d="M251.254 267.86c-2.834-2.694-2.694-7.382-1.277-11.032 1.417-3.651 4.501-6.444 7.947-8.292a25.194 25.194 0 0121.943-.706 10.422 10.422 0 00-8.42 4.939c-1.551 2.583-1.901 5.715-3.184 8.444a13.278 13.278 0 01-17.009 6.647z"
      ></path>
      <path
        fill={theme ? theme.secondary[700] : '#6E7382'}
        d="M248.384 282.094a2.022 2.022 0 010-.426v-1.224a48.99 48.99 0 01.374-4.49 58.23 58.23 0 011.201-6.578 30.29 30.29 0 012.997-7.615 31.556 31.556 0 014.91-6.554 30.776 30.776 0 015.143-4.274c.781-.543 1.545-.951 2.198-1.336.653-.385 1.254-.635 1.75-.863l1.131-.472a2.3 2.3 0 01.402-.146 1.96 1.96 0 01-.373.198l-1.108.525c-.466.245-1.044.548-1.703.91-.659.361-1.387.81-2.163 1.364a31.831 31.831 0 00-5.061 4.286 32.25 32.25 0 00-4.84 6.508c-2.916 5.05-3.68 10.35-4.257 14.07a62.504 62.504 0 00-.466 4.473 81.47 81.47 0 00-.076 1.218 1.854 1.854 0 01-.059.426zM221.305 237.066c-5.831 3.499-5.79 6.695-4.816 9.709.973 3.015 4.53 5.102 7.487 3.977 1.673-.641 2.88-2.093 3.918-3.551 1.038-1.458 2-3.021 3.452-4.082s3.546-1.446 5.003-.408"
      ></path>
      <path
        fill={theme ? theme.secondary[600] : '#888D9B'}
        d="M216.961 240.909c1.516-2.099 5.248-2.706 7.639-1.656 2.39 1.049 4.081 3.125 5.656 5.195 1.574 2.07 3.067 4.263 5.219 5.703 2.151 1.44 5.154 1.965 7.3.513a6.239 6.239 0 002.479-4.297c.19-1.694.076-3.408-.339-5.062-.513-2.437-1.353-4.979-3.3-6.531-2.169-1.72-5.184-1.801-7.96-1.714-3.183.105-6.414.344-9.393 1.446-2.98 1.102-6.036 3.499-7.301 6.414"
      ></path>
      <path
        fill={theme ? theme.secondary[700] : '#6E7382'}
        d="M243.557 277.441a3.116 3.116 0 01-.041-.501l-.053-1.441c-.035-1.282-.093-3.084-.157-5.3a324.989 324.989 0 00-.327-7.86c-.157-2.957-.39-6.205-.839-9.581a30.615 30.615 0 00-.957-4.863 25.252 25.252 0 00-1.778-4.257 22.992 22.992 0 00-4.694-6.216 17.914 17.914 0 00-4.339-2.968 13.442 13.442 0 00-1.317-.583 2.404 2.404 0 01-.461-.204c.162.039.322.087.478.146.463.143.915.318 1.353.525a17.192 17.192 0 014.432 2.915 22.808 22.808 0 014.793 6.239 24.836 24.836 0 011.813 4.298 30.15 30.15 0 01.98 4.916c.449 3.393.665 6.647.816 9.609.152 2.962.216 5.621.263 7.866.046 2.245.058 4.053.058 5.301v1.446c.007.171-.001.343-.023.513z"
      ></path>
      <path
        fill={theme ? theme.secondary[600] : '#888D9B'}
        d="M249.895 251.684c-3.143-3.703-3.563-9.65-3.097-14.484.467-4.834 1.581-9.703.817-14.502-.449-2.84-1.551-5.551-1.924-8.409-.374-2.857.157-6.076 2.367-7.918 2.542-2.117 6.543-1.616 9.184.367 2.642 1.983 4.175 5.114 5.295 8.222 2.443 6.834 3.358 14.414 1.341 21.412-2.018 6.997-6.758 13.219-13.715 15.324"
      ></path>
      <path
        fill={theme ? theme.secondary[700] : '#6E7382'}
        d="M245.65 280.064a15.947 15.947 0 01-.648-2.489 26.298 26.298 0 01-.274-6.998 46.433 46.433 0 012.21-10.169c1.196-3.738 2.811-7.738 4.193-12.03a55.607 55.607 0 001.668-6.362c.382-2.007.656-4.033.822-6.07.266-3.455.33-6.922.192-10.385-.099-2.956-.25-5.347-.35-6.997a444.9 444.9 0 01-.105-1.901v-.496a.48.48 0 010-.169c.003.054.003.109 0 .163 0 .129.03.292.053.496.041.455.093 1.09.163 1.901.134 1.65.321 4.041.449 6.997a85.97 85.97 0 01-.128 10.415 56.512 56.512 0 01-.811 6.105 54.524 54.524 0 01-1.667 6.414c-1.388 4.309-3.015 8.298-4.216 12.024a47.274 47.274 0 00-2.263 10.105 27.184 27.184 0 00.175 6.968c.14.817.268 1.446.385 1.866.047.198.082.356.117.484a.737.737 0 01.035.128z"
      ></path>
      <path
        fill={theme ? theme.secondary[700] : '#6E7382'}
        d="M260.047 282.688h-27.272l-.624-5.248h27.896v5.248z"
      ></path>
      <path
        fill={theme ? theme.secondary[700] : '#6E7382'}
        d="M235.702 282.094l3.411 15.75h14.817l3.19-15.75h-21.418z"
      ></path>
      <path
        fill={theme ? theme.secondary[600] : '#888D9B'}
        d="M260.047 282.689c0 .087-5.995.14-13.412.116-7.417-.023-13.411-.105-13.411-.192 0-.088 5.994-.134 13.411-.111 7.417.023 13.412.105 13.412.187z"
      ></path>
      <path
        fill={theme ? theme.primary[500] : '#C0C2C9'}
        d="M29.064 278.853a12.038 12.038 0 00-7.446-.906 6.18 6.18 0 00-3.682 1.641c-.913 1.017-1.092 2.803 0 3.675a3.51 3.51 0 002.315.584c1.971 0 4.156-.364 5.729.817.893.687 1.49 1.8 2.569 2.13a2.54 2.54 0 002.788-1.237 4.334 4.334 0 00.317-3.201 4.886 4.886 0 00-2.59-3.503z"
      ></path>
      <path
        fill={theme ? '#222' : '#6E7382'}
        d="M34.346 298.671a3.945 3.945 0 01-.124-.893l-.24-2.459a33.607 33.607 0 00-.55-3.593 27.84 27.84 0 00-1.312-4.252 15.58 15.58 0 00-2.163-3.839 8.16 8.16 0 00-2.748-2.281 7.608 7.608 0 00-2.308-.687c-.3-.017-.6-.06-.893-.13.304-.038.61-.038.914 0 .833.06 1.647.272 2.404.625a8.04 8.04 0 012.892 2.301 15.106 15.106 0 012.246 3.915c.56 1.399.994 2.845 1.298 4.321.235 1.202.395 2.418.481 3.64.076 1.044.11 1.882.124 2.466.025.289.018.579-.021.866z"
      ></path>
      <path
        fill={theme ? theme.primary[500] : '#C0C2C9'}
        d="M34.23 268.838c-1.375 1.978-4.074 1.319-5.324.11-1.25-1.209-1.772-2.954-2.253-4.623-1.1-3.812-2.205-7.81-1.374-11.677a6.42 6.42 0 011.497-3.208 3.386 3.386 0 013.215-1.071c1.374.357 2.205 1.683 2.816 2.947a27.98 27.98 0 012.748 11.965c0 1.93-.22 3.95-1.312 5.543"
      ></path>
      <path
        fill={theme ? '#222' : '#6E7382'}
        d="M34.174 296.788a1.65 1.65 0 010-.419v-1.196c0-1.03 0-2.527-.048-4.382-.096-3.696-.412-8.806-1.03-14.425-.618-5.619-1.443-10.66-2.191-14.287a51.318 51.318 0 00-.522-2.439c-.172-.714-.296-1.339-.426-1.834-.13-.494-.206-.858-.282-1.16a1.873 1.873 0 01-.069-.413c.066.124.114.256.145.392l.343 1.14c.158.495.316 1.113.495 1.827.178.715.384 1.525.577 2.432a134.424 134.424 0 012.3 14.301c.619 5.626.894 10.75.921 14.459 0 1.855 0 3.352-.069 4.389 0 .481-.054.88-.068 1.189-.006.144-.031.288-.076.426z"
      ></path>
      <path
        fill={theme ? theme.primary[500] : '#C0C2C9'}
        d="M38.055 271.675a7.186 7.186 0 01-1.12-6.621 12.72 12.72 0 013.923-5.695 21.075 21.075 0 017.027-4.121 7.473 7.473 0 013.16-.536 3.296 3.296 0 012.65 1.601c.736 1.408 0 3.118-.741 4.512a52.853 52.853 0 01-4.61 7.027c-1.373 1.786-2.967 3.545-5.075 4.348-2.11.804-4.3.687-5.413-.748"
      ></path>
      <path
        fill={theme ? '#222' : '#6E7382'}
        d="M34.154 286.91a7.928 7.928 0 010-1.25c.048-.797.158-1.958.384-3.373a46.03 46.03 0 013.153-10.736 30.876 30.876 0 016.038-9.403c.445-.47.92-.911 1.422-1.319.213-.186.405-.371.604-.515l.55-.378c.33-.258.682-.488 1.05-.687a38.499 38.499 0 00-3.434 3.064 32.959 32.959 0 00-5.886 9.369 46.787 46.787 0 00-2.06 5.77c-.537 1.806-.894 3.468-1.169 4.87a39.627 39.627 0 00-.494 3.338c-.025.42-.078.837-.158 1.25z"
      ></path>
      <defs>
        <filter
          id="filter0_dd"
          width="258.604"
          height="177"
          x="14.698"
          y="50.5"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="0.5"></feOffset>
          <feGaussianBlur stdDeviation="1"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.08 0"></feColorMatrix>
          <feBlend
            in2="effect1_dropShadow"
            result="effect2_dropShadow"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
};

export default IllustrationProspectView;
